import $ from "jquery"
import "jquery-match-height";

function matchHeight() {
    $('.js-match-height-how-title').matchHeight();
    $('.js-match-height-how-content').matchHeight();
    $('.js-match-height-how-from').matchHeight();
    $('.js-match-height-team-name').matchHeight();
    $('.js-match-height-team-position').matchHeight();
    $('.js-match-height-team-description').matchHeight();
    $('.js-what-match-height-column').matchHeight();
}

matchHeight();

$(window).on('resize', function() {
    matchHeight();
});

$('.js-what-item').each(function() {
    $(this).on('click', function() {
        $('.what__item').removeClass('what__item--active');
        $(this).addClass('what__item--active');
    });
});